<template>
  <div class="bet-page">
    <van-nav-bar
      class="bet-nav"
      title="投注记录"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="bet-tabs">
      <span
        v-for="t in tabs"
        :key="t.key"
        :class="['tab', { on: range === t.key }]"
        @click="switchRange(t.key)"
      >{{ t.label }}</span>
    </div>
    <div class="bet-stats" v-if="stats">
      <div class="st">
        <b :class="profitClass(stats.profit)">{{ fmtSigned(stats.profit) }}</b>
        <i>总盈亏</i>
      </div>
      <div class="st">
        <b>{{ stats.periods || 0 }}</b>
        <i>总期数</i>
      </div>
      <div class="st">
        <b>{{ fmtNum(stats.bet_amount) }}</b>
        <i>总流水</i>
      </div>
      <div class="st">
        <b>{{ fmtNum(stats.rebate) }}</b>
        <i>总回水</i>
      </div>
    </div>
    <div class="bet-meta" v-if="total > 0">
      <span>共 {{ total }} 条记录</span>
      <em>点击查看详情</em>
    </div>
    <div class="bet-list" v-if="list.length">
      <div
        class="bet-card"
        v-for="(item, idx) in list"
        :key="item.id || idx"
        :class="cardClass(item)"
        @click="openDetail(item)"
      >
        <div class="bar"></div>
        <div class="main">
          <div class="row1">
            <span class="expect">{{ item.expect }}</span>
            <span class="time">{{ item.time_short }}</span>
          </div>
          <div class="row2">
            投注内容：{{ item.playtitle }}
            <b>¥{{ fmtNum(item.amount) }}</b>
          </div>
        </div>
        <div class="side" :class="sideClass(item)">
          <div class="stxt">{{ item.status_text }}</div>
          <div class="samt" v-if="item.status === 1">
            {{ item.won ? '+' : '' }}¥{{ fmtNum(item.won ? item.profit : item.amount) }}
          </div>
          <div class="samt pending" v-else>—</div>
        </div>
      </div>
      <div class="more" v-if="page < pages" @click="loadMore">加载更多</div>
      <div class="more done" v-else>没有更多了</div>
    </div>
    <div class="bet-empty" v-else-if="!loading">
      <img src="/static/image/mescroll-empty.png" alt="" />
      <p>暂无投注记录</p>
    </div>

    <van-popup v-model="detailShow" position="bottom" round :style="{ maxHeight: '78%' }">
      <div class="detail" v-if="detail">
        <div class="d-head">
          <b>注单详情</b>
          <span :class="['badge', sideClass(detail)]">{{ detail.status_text }}</span>
        </div>
        <div class="d-row"><i>游戏名称</i><em>{{ detail.game_name }}</em></div>
        <div class="d-row"><i>投注内容</i><em>{{ detail.playtitle }}</em></div>
        <div class="d-row"><i>所属期号</i><em>{{ detail.expect }}</em></div>
        <div class="d-row">
          <i>开奖结果</i>
          <em class="open">{{ detail.open_result || '—' }}</em>
        </div>
        <div class="d-row"><i>投注金额</i><em>¥{{ fmtNum(detail.amount) }}</em></div>
        <div class="d-row">
          <i>中奖金额</i>
          <em>{{ detail.status === 1 && detail.won ? ('¥' + fmtNum(detail.win)) : '—' }}</em>
        </div>
        <div class="d-row">
          <i>盈亏</i>
          <em :class="profitClass(detail.profit)">
            {{ detail.status === 1 ? fmtSignedMoney(detail.profit) : '—' }}
          </em>
        </div>
        <div class="d-row"><i>投注时间</i><em>{{ detail.time_short }}</em></div>
        <div class="d-close" @click="detailShow = false">关闭</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "betRecord",
  data() {
    return {
      tabs: [
        { key: "today", label: "今日" },
        { key: "yesterday", label: "昨日" },
        { key: "days7", label: "近7日" },
        { key: "days30", label: "近30日" },
      ],
      range: "days30",
      list: [],
      stats: null,
      page: 1,
      pages: 1,
      total: 0,
      loading: false,
      detailShow: false,
      detail: null,
    };
  },
  created() {
    this.fetchList(true);
  },
  methods: {
    switchRange(key) {
      if (this.range === key) return;
      this.range = key;
      this.fetchList(true);
    },
    fetchList(reset) {
      var that = this;
      if (reset) {
        that.page = 1;
        that.list = [];
        that.pages = 1;
        that.total = 0;
      }
      if (that.loading) return;
      that.loading = true;
      that.$parent.showLoading();
      that.$apiFun
        .get(
          "/api/lotteryRecent?range=" +
            that.range +
            "&page=" +
            that.page +
            "&page_size=20"
        )
        .then(function (res) {
          that.loading = false;
          that.$parent.hideLoading();
          if (!res || res.code != 200) {
            that.$parent.showTost(0, (res && res.message) || "加载失败");
            return;
          }
          var data = res.data || {};
          that.stats = data.stats || null;
          that.total = data.total || 0;
          that.pages = data.pages || 1;
          that.page = data.page || 1;
          var rows = data.list || [];
          if (reset) that.list = rows;
          else that.list = that.list.concat(rows);
        })
        .catch(function () {
          that.loading = false;
          that.$parent.hideLoading();
        });
    },
    loadMore() {
      if (this.page >= this.pages || this.loading) return;
      this.page += 1;
      this.fetchList(false);
    },
    openDetail(item) {
      this.detail = item;
      this.detailShow = true;
    },
    cardClass(item) {
      if (!item || item.status !== 1) return "pending";
      return item.won ? "win" : "lose";
    },
    sideClass(item) {
      if (!item || item.status !== 1) return "pending";
      return item.won ? "win" : "lose";
    },
    profitClass(v) {
      var n = parseFloat(v);
      if (isNaN(n) || n === 0) return "";
      return n > 0 ? "up" : "down";
    },
    fmtNum(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return "0.00";
      return n.toFixed(2);
    },
    fmtSigned(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return "0.00";
      var s = n.toFixed(2);
      return n > 0 ? "+" + s : s;
    },
    fmtSignedMoney(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return "—";
      var s = "¥" + Math.abs(n).toFixed(2);
      if (n > 0) return "+" + s;
      if (n < 0) return "-" + s;
      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.bet-page {
  min-height: 100vh;
  background: #f3f5fb;
  padding-bottom: 24px;
}
.bet-nav {
  background: #fff !important;
}
.bet-tabs {
  display: flex;
  gap: 10px;
  padding: 12px 14px 8px;
  background: #fff;
  .tab {
    flex: 1;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    font-size: 13px;
    color: #5b6475;
    background: #f1f3f8;
  }
  .tab.on {
    color: #fff;
    background: linear-gradient(90deg, #7a6cff, #5b4fd6);
    font-weight: 600;
  }
}
.bet-stats {
  margin: 10px 12px 0;
  padding: 12px 6px;
  background: #eef1f7;
  border-radius: 10px;
  display: flex;
  .st {
    flex: 1;
    text-align: center;
    b {
      display: block;
      font-size: 15px;
      color: #1c263d;
      font-weight: 700;
      line-height: 1.2;
    }
    i {
      display: block;
      margin-top: 4px;
      font-style: normal;
      font-size: 11px;
      color: #8a93a3;
    }
    .up { color: #16a34a; }
    .down { color: #e53935; }
  }
}
.bet-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 6px;
  font-size: 12px;
  color: #8a93a3;
  em {
    font-style: normal;
    color: #7a6cff;
  }
}
.bet-list {
  padding: 0 12px 20px;
}
.bet-card {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 12px 12px 12px 14px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(28, 38, 61, 0.04);
  .bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #c5cad6;
  }
  &.win .bar { background: #22c55e; }
  &.lose .bar { background: #ef4444; }
  &.pending .bar { background: #a78bfa; }
  .main {
    flex: 1;
    min-width: 0;
  }
  .row1 {
    display: flex;
    align-items: baseline;
    gap: 10px;
    .expect {
      font-size: 15px;
      font-weight: 700;
      color: #1c263d;
    }
    .time {
      font-size: 12px;
      color: #9aa3b2;
    }
  }
  .row2 {
    margin-top: 6px;
    font-size: 13px;
    color: #5b6475;
    b {
      margin-left: 4px;
      color: #1c263d;
      font-weight: 600;
    }
  }
  .side {
    text-align: right;
    margin-left: 10px;
    flex-shrink: 0;
    .stxt {
      font-size: 13px;
      font-weight: 600;
    }
    .samt {
      margin-top: 4px;
      font-size: 14px;
      font-weight: 700;
    }
    .samt.pending {
      color: #9aa3b2;
      font-weight: 500;
    }
    &.win .stxt,
    &.win .samt { color: #16a34a; }
    &.lose .stxt,
    &.lose .samt { color: #e53935; }
    &.pending .stxt { color: #7a6cff; }
  }
}
.more {
  text-align: center;
  color: #8a93a3;
  font-size: 12px;
  padding: 10px 0 4px;
  &.done { color: #c0c6d2; }
}
.bet-empty {
  text-align: center;
  padding: 60px 20px;
  img { width: 120px; opacity: 0.9; }
  p { margin-top: 10px; color: #9aa3b2; font-size: 13px; }
}
.detail {
  padding: 16px 18px 22px;
  .d-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    b { font-size: 17px; color: #1c263d; }
    .badge {
      font-size: 12px;
      padding: 3px 10px;
      border-radius: 12px;
      font-weight: 600;
      &.win { color: #16a34a; background: #e8f8ee; }
      &.lose { color: #e53935; background: #fdebec; }
      &.pending { color: #7a6cff; background: #efeaff; }
    }
  }
  .d-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f2f7;
    i {
      font-style: normal;
      color: #8a93a3;
      font-size: 14px;
    }
    em {
      font-style: normal;
      color: #1c263d;
      font-size: 14px;
      font-weight: 500;
      text-align: right;
      max-width: 62%;
      word-break: break-all;
    }
    .open { color: #6d5efc; font-weight: 600; }
    .up { color: #16a34a; }
    .down { color: #e53935; }
  }
  .d-close {
    margin-top: 18px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 23px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(90deg, #7a6cff, #5b4fd6);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/betRecord.vue